import { Navigate } from 'react-router-dom';
import { OutletTransition } from '@/shared/components/outlet-transition';
import { resolveHomePath, useAuth } from '@/shared/lib/auth';
import { isNpsSession } from '@/shared/lib/nps-session';
import { useNpsMe } from '../api/use-nps';
import { Skeleton } from '@/shared/ui/skeleton';

/** Layout NPS com faixa de branding em largura total da área de conteúdo. */
export function NpsLayout() {
  const { user, authSource, startPath } = useAuth();
  const { data: me, isLoading } = useNpsMe({ enabled: isNpsSession(authSource) });

  if (!user) return null;
  if (!isNpsSession(authSource)) {
    return <Navigate to={startPath ?? resolveHomePath(user, 'legacy')} replace />;
  }

  const primary = me?.user_preference?.primary_color ?? '#2563eb';
  const secondary = me?.user_preference?.secondary_color ?? primary;

  return (
    <div className="flex min-w-0 flex-col">
      <div
        className="relative mb-5 flex h-12 w-full shrink-0 items-center gap-3 border-b border-black/10 px-4 shadow-sm lg:h-14 lg:px-8"
        style={{
          background: `linear-gradient(105deg, ${primary} 0%, ${secondary} 100%)`,
        }}
      >
        <div className="pointer-events-none absolute inset-0 bg-gradient-to-r from-white/10 via-transparent to-black/5" />
        <div className="relative flex min-w-0 flex-1 items-center gap-3">
          {isLoading ? (
            <Skeleton className="size-8 shrink-0 rounded-md bg-white/25 lg:size-9" />
          ) : me?.user_preference?.logo ? (
            <img
              src={me.user_preference.logo}
              alt=""
              className="h-7 w-auto max-w-[100px] shrink-0 object-contain lg:h-8 lg:max-w-[120px]"
            />
          ) : (
            <div className="grid size-8 shrink-0 place-items-center rounded-md bg-white/20 text-xs font-semibold text-white lg:size-9 lg:text-sm">
              {(me?.name ?? 'NPS').slice(0, 2).toUpperCase()}
            </div>
          )}
          {!isLoading && me ? (
            <p className="truncate text-sm font-medium text-white lg:text-[15px]">
              {me.name}
              {me.last_name ? ` ${me.last_name}` : ''}
            </p>
          ) : isLoading ? (
            <Skeleton className="h-4 w-32 rounded bg-white/25" />
          ) : null}
        </div>
      </div>

      <div className="px-4 lg:px-8">
        <OutletTransition className="min-w-0 flex-1" />
      </div>
    </div>
  );
}
